export default __webpack_public_path__ + "static/grc-bfbfe42e89af513a29c35211a2ea209d.gif";